import { Fetch, FetchQueue } from "@sopheos/orbjs_fetch";

let _instanceRequest = null;
let _instanceApi = null;
let _instancePay = null;

/**
 *
 * @returns {Fetch}
 */
export function useRequest() {
  if (!_instanceRequest) {
    _instanceRequest = new Fetch();
  }
  return _instanceRequest;
}

/**
 *
 * @returns {FetchQueue}
 */
export function useFetchApi() {
  if (!_instanceApi) {
    const http = useRequest();
    const authStore = useAuthStore();
    const tokenStore = useTokenStore();
    const localStorage = useLocalStorage();
    const sessionStorage = useSessionStorage();

    _instanceApi = new FetchQueue(
      {
        baseUrl: import.meta.env.VITE_API_URL,
      },
      {
        renew: (extra) => {
          const fetchApi = useFetchApi();
          return http
            .get("/v1/token/renew", null, {
              baseUrl: import.meta.env.VITE_API_URL,
              headers: {
                Authorization: `Bearer ${fetchApi.accessStore.token}`,
              },
            })
            .then(({ body }) => {
              if (!extra || !extra.control) {
                body.hasControl = false;
              }
              useSetToken(body);
            })
            .catch((e) => {
              authStore.reset();

              sessionStorage.remove("access");
              tokenStore.resetAccess();
              throw e;
            });
        },
        refresh: (extra) => {
          const fetchApi = useFetchApi();
          return http
            .get(
              "/v1/token/refresh",
              { token: fetchApi.refreshStore.token },
              {
                baseUrl: import.meta.env.VITE_API_URL,
              },
            )
            .then(({ body }) => {
              if (!extra || !extra.control) {
                body.hasControl = false;
              }
              useSetToken(body);
            })
            .catch((e) => {
              authStore.reset();

              sessionStorage.remove("access");
              tokenStore.resetAccess();
              localStorage.remove("refresh");
              throw e;
            });
        },
        handleErrors,
      },
    );
  }
  return _instanceApi;
}

/**
 *
 * @returns {FetchQueue}
 */
export function useFetchPay() {
  if (!_instancePay) {
    _instancePay = new FetchQueue(
      {
        baseUrl: import.meta.env.VITE_PAY_API,
      },
      {
        generate: () => {
          const fetchApi = useFetchApi();
          return fetchApi.get("/v1/token/pay").then(({ body }) => {
            const fetchPay = useFetchPay();
            fetchPay.accessStore = {
              token: body.accessToken,
              delay: body.accessExpiresIn * 1000,
              exp: Date.now() + body.accessExpiresIn * 1000,
            };
          });
        },
        handleErrors,
      },
    );
  }
  return _instancePay;
}

async function handleErrors(e) {
  const snackbar = useSnackbar();
  switch (e.status) {
    case 401:
      await useLogout(true);
      snackbar.add({
        key: snackbar.LOGOUT,
        type: snackbar.TYPE_ERROR,
        message: useErrorWording("http", 401, "logout"),
        close: true,
      });
      break;
    case 403:
      if (e.data.error === "user_state") {
        await useLogout(true);
        snackbar.add({
          key: snackbar.LOGOUT,
          type: snackbar.TYPE_ERROR,
          message: useErrorWording("http", 403, "user_state"),
          close: true,
        });
      }
      break;
    case 500:
      snackbar.add({
        key: snackbar.ERROR,
        type: snackbar.TYPE_ERROR,
        message: useErrorWording("http", 500, e.code),
        close: true,
      });
      break;
    default:
      break;
  }
}
